var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.578125,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FF5B51",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5778 21.3333C17.5778 17.8355 20.4133 15 23.9111 15C27.4089 15 30.2445 17.8355 30.2445 21.3333C30.2445 24.8311 27.4089 27.6667 23.9111 27.6667C20.4133 27.6667 17.5778 24.8311 17.5778 21.3333ZM23.9111 17C21.5179 17 19.5778 18.9401 19.5778 21.3333C19.5778 23.7266 21.5179 25.6667 23.9111 25.6667C26.3044 25.6667 28.2445 23.7266 28.2445 21.3333C28.2445 18.9401 26.3044 17 23.9111 17ZM12.9111 37.3333C12.9111 33.8355 15.7467 31 19.2445 31H28.5778C32.0756 31 34.9111 33.8355 34.9111 37.3333V40C34.9111 40.5523 34.4634 41 33.9111 41C33.3588 41 32.9111 40.5523 32.9111 40V37.3333C32.9111 34.9401 30.971 33 28.5778 33H19.2445C16.8512 33 14.9111 34.9401 14.9111 37.3333V40C14.9111 40.5523 14.4634 41 13.9111 41C13.3588 41 12.9111 40.5523 12.9111 40V37.3333ZM43.9516 24.7071C44.3421 24.3166 44.3421 23.6834 43.9516 23.2929C43.561 22.9024 42.9279 22.9024 42.5374 23.2929L37.9111 27.9191L35.9516 25.9596C35.561 25.569 34.9279 25.569 34.5374 25.9596C34.1468 26.3501 34.1468 26.9832 34.5374 27.3738L37.204 30.0404C37.3916 30.228 37.6459 30.3333 37.9111 30.3333C38.1763 30.3333 38.4307 30.228 38.6182 30.0404L43.9516 24.7071Z",
    fill: "#FF5B51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanVerification);
export default __webpack_public_path__ + "static/media/human-verification.c1417218a0b94cd58a223cf9abf9433e.svg";
export { ForwardRef as ReactComponent };